// Swatch promo badges (snippets/swatch-promo-badge.liquid).
// Liquid renders matching badges hidden; this reveals each one only inside its start/end window,
// using the shopper's clock (same approach as the announcement bar), so cached pages can't show
// them early or late. Re-checks at the next start/end time and when the tab regains focus.
(function () {
  var badges = document.querySelectorAll('.swatch-badge--promo[data-promo-start]');
  if (!badges.length) return;
  var timer;
  function update() {
    clearTimeout(timer);
    var now = Math.floor(Date.now() / 1000);
    var next = Infinity;
    badges.forEach(function (badge) {
      var start = parseInt(badge.getAttribute('data-promo-start'), 10);
      var end = parseInt(badge.getAttribute('data-promo-end'), 10);
      badge.hidden = !(now >= start && now < end);
      if (start > now && start < next) next = start;
      if (end > now && end < next) next = end;
    });
    if (next - now <= 86400) timer = setTimeout(update, (next - now) * 1000 + 250);
  }
  update();
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) update();
  });
})();

$(document).ready(function () {
  // Make body the active element on page load
  document.body.focus();
  document.activeElement.blur();
});

function updateSearchUrl(searchValue) {
    const newUrl = window.location.origin + '/search?q=' + searchValue;
    window.history.replaceState(null, '', newUrl);
}

// Function to show thumb image
function showThumbImage(containerSelector) {
    showImages(containerSelector, true);
}

// Function to show featured image
function showFeaturedImage(containerSelector) {
    showImages(containerSelector, false);
}

function showImages(containerSelector, showThumb) {
    const productCardContainers = document.querySelectorAll(containerSelector);
    productCardContainers.forEach(productCardContainer => {
        const thumbImage = productCardContainer.querySelector('.thumbImage');
        const featuredImage = productCardContainer.querySelector('.featuredImage');

        if (thumbImage && featuredImage) {
            thumbImage.style.display = showThumb ? 'block' : 'none';
            featuredImage.style.display = showThumb ? 'none' : 'block';
        }
    });
}
